import useAppHooks from "../../../../../../shared/hooks/useAppHooks";
import {
  fetchExamQuestionRequest,
  setCurrentQuestionIndex,
  setActiveSection,
} from "../../../../../../redux/exam/examSlice";
import "./QuestionGrid.css";

export default function QuestionGrid({ onSelect, registerRef }) {
  const { dispatch, selector } = useAppHooks();
  const { questionsData, testDetails, paperId, testType } = selector(
    (s) => s.examSlice
  );

  // ✅ Group questions by "subject + section_name"
  const grouped = [];
  const map = {};

  questionsData.forEach((q) => {
    const key = `${q.subject} ${q.section_name || ""}`.trim(); // e.g. "Physics Sec A"
    if (!map[key]) map[key] = [];
    map[key].push(q);
  });

  for (const key in map) {
    grouped.push({ section: key, questions: map[key] });
  }

  const getClassByStatus = (status) => {
    switch (status) {
      case "answered":
        return "question-box answered";
      case "unanswered":
        return "question-box unanswered";
      case "marked":
        return "question-box marked";
      case "answered_marked":
        return "question-box answered-marked";
      case "current":
        return "question-box current";
      default:
        return "question-box not-visited";
    }
  };

  return (
    <div>
      {grouped.map((group, groupIdx) => (
        <div key={groupIdx} className="question-section">
          <h6 className="question-section-title">{group.section}</h6>

          <div className="question-grid">
            {group.questions.map((q, idx) => (
              <div
                key={q.qid}
                ref={(el) => {
                  // Register ref for first question of each section
                  if (idx === 0 && registerRef) registerRef(group.section, el);
                }}
                className={getClassByStatus(q.status)}
                onClick={() => {
                  // Find global index of the question
                  const globalIndex = questionsData.findIndex(
                    (ques) => ques.qid === q.qid
                  );

                  // ✅ Set the section in SectionTabs (Redux)
                  dispatch(setActiveSection(group.section));

                  // ✅ Update question
                  dispatch(setCurrentQuestionIndex(globalIndex));
                  dispatch(
                    fetchExamQuestionRequest({
                      paperId: paperId,
                      paperType: testDetails?.paper_type || testType?.id,
                      qid: q.qid,
                      testId: testDetails?.testId,
                    })
                  );

                  // Callback for parent (optional)
                  onSelect(q.qid);
                }}
              >
                {idx + 1}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
